import * as React from "react";

import { AtcDto, ScheduledExchangesDto, PriceSpreadDto, CongestionIncomeDto, LtnDto, ShadowAuctionAtcDto, IntradayAtcDto } from "core/backend/data";
import TDatetime from "components/TDatetime";
import { keys } from "ts-transformer-keys";

interface OwnProps {
    border: string;
    date: Date;
    left: number;
    atcData: AtcDto[];
    qtyData: ScheduledExchangesDto[];
    psData: PriceSpreadDto[];
    ciData: CongestionIncomeDto[];
    ltnData: LtnDto[];
    sAtcData: ShadowAuctionAtcDto[];
    iAtcData: IntradayAtcDto[];
}


const Row = ({ border, date, atcData, qtyData, psData, ciData, ltnData, sAtcData, iAtcData, left }: OwnProps) => {
    const hasAtcData = keys<AtcDto>().map(m => m.toString()).includes("border_" + border.toUpperCase());
    const hasQtyData = keys<ScheduledExchangesDto>().map(m => m.toString()).includes("border_" + border.toUpperCase());
    const hasPsData = keys<PriceSpreadDto>().map(m => m.toString()).includes("border_" + border.toUpperCase());
    const hasCiData = keys<CongestionIncomeDto>().map(m => m.toString()).includes("border_" + border.toUpperCase());
    const hasLtnData = keys<LtnDto>().map(m => m.toString()).includes("border_" + border.toUpperCase());
    const hasSAtcData = keys<ShadowAuctionAtcDto>().map(m => m.toString()).includes("border_" + border.toUpperCase());
    const hasIAtcData = keys<IntradayAtcDto>().map(m => m.toString()).includes("initial_" + border.toUpperCase());
    return <tr>
        <TDatetime rowSpan={1} date={date} left={left} />
        {hasAtcData && <td>{atcData.length === 0 ? "..." : atcData.filter(f => f.dateTimeUtc.replace(":00Z", ":00.000Z") === date.toISOString()).map(m => eval("m.border_" + border.toUpperCase()))[0]}</td>}
        {hasQtyData && <td> {qtyData.length === 0 ? "..." : qtyData.filter(f => f.dateTimeUtc.replace(":00Z", ":00.000Z") === date.toISOString()).map(m => eval("m.border_" + border.toUpperCase()))[0]}</td>}
        {hasPsData && <td>{psData.length === 0 ? "..." : psData.filter(f => f.dateTimeUtc.replace(":00Z", ":00.000Z") === date.toISOString()).map(m => eval("m.border_" + border.toUpperCase()))[0]}</td>}
        {hasCiData && <td>{ciData.length === 0 ? "..." : ciData.filter(f => f.dateTimeUtc.replace(":00Z", ":00.000Z") === date.toISOString()).map(m => eval("m.border_" + border.toUpperCase()))[0]}</td>}
        {hasLtnData && <td>{ltnData.length === 0 ? "..." : ltnData.filter(f => f.dateTimeUtc.replace(":00Z", ":00.000Z") === date.toISOString()).map(m => eval("m.border_" + border.toUpperCase()))[0]}</td>}
        {hasSAtcData && <td>{sAtcData.length === 0 ? "..." : sAtcData.filter(f => f.dateTimeUtc.replace(":00Z", ":00.000Z") === date.toISOString()).map(m => eval("m.border_" + border.toUpperCase()))[0]}</td>}
        {hasIAtcData && <td>{iAtcData.length === 0 ? "..." : iAtcData.filter(f => f.dateTimeUtc.replace(":00Z", ":00.000Z") === date.toISOString()).map(m => eval("m.initial_" + border.toUpperCase()))[0]}</td>}
    </tr >;
}

export default Row;